import React from "react";
import { EsseMenuO } from "lovedicons/dist/esseO";
import Sidebar from "./Sidebar";

const MenuIcon = ({
  showSidebar,
  setShowSidebar,
  setCreatedFromBrand,
  togglePopupShow,
  handleShowAddUser,
}) => {
  return (
    <>
      <EsseMenuO
        className="xl:hidden block mx-2 w-5 h-5"
        onClick={() => setShowSidebar(true)}
      />{" "}
      <section
        className={`fixed top-0 left-0 z-50 h-screen bg-white shadow-lg transform ${
          showSidebar ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out xl:hidden`}
      >
        <Sidebar
          setShowSidebar={setShowSidebar}
          setCreatedFromBrand={setCreatedFromBrand}
          togglePopupShow={togglePopupShow}
          handleShowAddUser={handleShowAddUser}
        />
      </section>
    </>
  );
};

export default MenuIcon;
